export const OTP_ERROR_MESSAGE = "OTP is Wrong";

export const DOCTOR_SLUG_BOOKING_CONTAINT = {
    BOOKINGTEXT: 'Book An Appointment',
    CONTAINT: ' Copy paste the link shared by your doctor'
}